var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOutDown"}},[(_vm.showBtn)?_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
      el: '#' + _vm.toId,
      container: '#' + _vm.elId,
      offset: -50
    }),expression:"{\n      el: '#' + toId,\n      container: '#' + elId,\n      offset: -50\n    }"}],staticClass:"btn",attrs:{"id":"go-top-btn"}},[_c('i',{staticClass:"icon-arrow-up"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }